import { httpClient } from '@/infra/protocols/http';
import { IContextDTO } from '@/modules/scripts/dtos/context.dto';
import { IContext } from '@/modules/scripts/entities/context.entity';
import { ContextMapper } from '@/modules/scripts/mappers/context.mapper';

function removeUndefined(obj: object): object {
  return Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined));
}

export async function updateContextConfigurationScript(
  params: UpdateContextConfigurationScriptService.Params,
  data: UpdateContextConfigurationScriptService.Payload,
): Promise<UpdateContextConfigurationScriptService.Response> {
  const { ...context } = data;

  const body: { conteudoContexto: IContextDTO; urls?: string[] } = {
    conteudoContexto: removeUndefined(ContextMapper.toDTO(context)),
  };

  const response = await httpClient.put<UpdateContextConfigurationScriptService.Data>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/roteiro/contexto`,
    body,
  );

  return {
    goal: response.objetivo,
    topic: response.temaCentral,
    audience: response.publicoAlvo,
    openingText: response.textoAbertura,
    closingText: response.textoFechamento,
  };
}

export namespace UpdateContextConfigurationScriptService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
  }

  export type Payload = IContext;

  export interface Data {
    objetivo?: string;
    temaCentral?: string;
    publicoAlvo?: string;
    textoAbertura?: string;
    textoFechamento?: string;
  }

  export interface Response {
    goal?: string;
    topic?: string;
    audience?: string;
    openingText?: string;
    closingText?: string;
  }
}
